module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Update":"Обновить","new_version":"Доступна новая версия!"},"en":{"new_version":"New version available!"}}')
  delete Component.options._Ctor
}
